import axios from 'axios'
import units from '@/units.js'

export default {
  list: async (start, end) => {
    start = start ? start.toISOString() : '';
    end   = end   ? end.toISOString()   : '';

    const url = `/table/?start=${start}&end=${end}`;
    return await axios.get(url);
  },

  last: async () => {
    const url = '/table/last/';
    return await axios.get(url);
  },

  headers: async () => {
    const url = '/table/headers/';
    return await axios.get(url);
  },

  aggregate: async (unit, start, end) => {
    const url = '/table/aggregate/';
    return await axios.get(url, {
      params: {
        unit  : unit,
        start : start.toISOString(),
        end   : units.date2isoformat_tz(end),
      }
    });
  }
}
